import React, { useEffect, useState } from 'react';
import './NavbarButton.css';
import InputSerach from '../InputSerach/InputSearchs';
import Favoritos from '../Favoritos/Favoritos';
import baseURL from '../url';
import { Link as Anchor } from 'react-router-dom';

// IMPORTACIÓN DE ICONOS MINIMALISTAS
import { FaWhatsapp, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

export default function NavbarButton() {

    const [tienda, setTienda] = useState([]);
    const [openSocials, setOpenSocials] = useState(false);

    useEffect(() => {
        cargarTienda();
    }, []);

    const cargarTienda = () => {
        fetch(`${baseURL}/tiendaGet.php`)
            .then(response => response.json())
            .then(data => {
                setTienda(data.tienda.reverse()[0] || []);
            })
            .catch(error => console.error('Error al cargar datos:', error));
    };

    const abrirMapa = (e) => {
        e.preventDefault(); // Evita que la ruta intente cambiar localmente
        if (tienda.direccion) {
            const dir = encodeURIComponent(tienda.direccion);
            window.open(`https://www.google.com/maps/search/?api=1&query=${dir}`, "_blank");
        }
    };

    return (
        <div className='NavbarButtonContent'>
            <div className={`Modalsocials ${openSocials ? 'active' : ''}`}>

                {/* BOTÓN EMAIL */}
                <Anchor 
                    to={`mailto:${tienda.email}`} 
                    target="_blank"
                    style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                >
                    <FaEnvelope style={{ fontSize: '15px' }} />
                    <span>Email</span>
                </Anchor>

                {/* BOTÓN WHATSAPP */}
                <Anchor 
                    to={`https://wa.me/${tienda.telefono}`} 
                    target="_blank"
                    style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                >
                    <FaWhatsapp style={{ fontSize: '17px' }} />
                    <span>Whatsapp</span>
                </Anchor>

                {/* BOTÓN DIRECCIÓN */}
                <Anchor 
                    to="#" 
                    onClick={abrirMapa} 
                    style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                >
                    <FaMapMarkerAlt style={{ fontSize: '15px' }} />
                    <span>Dirección</span>
                </Anchor>

            </div>

            <div className='NavbarButton'>

                <InputSerach />

                <button
                    className={`plusButton ${openSocials ? 'open' : ''}`}
                    onClick={() => setOpenSocials(!openSocials)}
                >
                    +
                </button>

                <Favoritos />

            </div>
        </div>
    );
}